/**
 * A Stimulus controller that disables target elements
 *
 * @module DisableController
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['element'];

  toggle() {
    this.elementTargets.forEach((target) => {
      target.disabled = !target.disabled;
    });
  }
}
